import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {

  private countRequest = 0;
  private showTimer: ReturnType<typeof setTimeout> | null = null;
  private visible = false;
  /** Evita flash do overlay em requests rápidos. */
  private readonly showDelayMs = 250;

  constructor(private loaderService: LoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const ignoreLoading = req.params.has('ignoreLoading')
      || this.loaderService.isAutomaticLoaderSuppressed();

    if (!ignoreLoading) {
      this.countRequest++;
      if (this.countRequest === 1 && !this.showTimer && !this.visible) {
        this.showTimer = setTimeout(() => {
          this.showTimer = null;
          if (this.countRequest > 0 && !this.loaderService.isAutomaticLoaderSuppressed()) {
            this.visible = true;
            this.loaderService.show();
          }
        }, this.showDelayMs);
      }
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (!ignoreLoading) {
          this.countRequest = Math.max(0, this.countRequest - 1);
          if (this.countRequest === 0) {
            if (this.showTimer) {
              clearTimeout(this.showTimer);
              this.showTimer = null;
            }
            if (this.visible) {
              this.visible = false;
              this.loaderService.hide();
            }
          }
        }
      })
    );
  }
}
